export var masterFirebaseConfig = {
   apiKey: "AIzaSyA34PLXP6NfLBE-Ylu3iTx3BH_eQMGGKpU",
   authDomain: "metacritic-rebuild.firebaseapp.com",
   databaseURL: "https://metacritic-rebuild.firebaseio.com",
   projectId: "metacritic-rebuild",
   storageBucket: "metacritic-rebuild.appspot.com",
   messagingSenderId: "283229208591"
 };



// WEBPACK FOOTER //
// C:/Users/Dtuck/Desktop/projects/Javascript/metacritic-rebuild/src/app/api-keys.ts